/**
 * intersect カスタムディレクティブ
 * 要素が画面内に表示された時にイベントを発火する
 * 例)
 * <div
 *   v-intersect
 *   @intersect="handler">
 *  </div>
 *
 * 参考
 * https://zenn.dev/coconala/articles/a89a93ab039875
 */

const observers = {}
let currentId = 0

/**
 * intersectイベント発火
 * @param vNode 対象要素の仮想ノード
 * @param entry 対象要素の交差状態
 */
const emitIntersectEvent = (vNode, entry) => {
  const handlers = vNode.data?.on
  if (handlers && 'intersect' in handlers) {
    const handler = handlers.intersect

    if (typeof handler === 'function') {
      handler(entry)
    } else {
      handler.forEach(f => f(entry))
    }
  }
}

/**
 * 要素の監視解除
 * @param el 対象要素
 */
const disconnect = (el) => {
  const id = el.dataset.intersectionObserverId
  if (id) {
    // eslint-disable-next-line no-unused-expressions
    observers[id]?.disconnect()
    delete observers[id]
  }
  el.removeAttribute('data-intersection-observer-id')
}

/**
 * カスタムディレクティブ
 */
export default {
  inserted(el, binding, vNode) {
    const { once, each, out } = binding.modifiers
    const observerOptions = typeof binding.value === 'object' ? binding.value : {}

    /** イベント発火判定 */
    const isFiring = (entry) => {
      if (each) return true

      if (out) {
        return !entry.isIntersecting
      }

      return entry.isIntersecting
    }

    // IntersectionObserverインスタンスの生成
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (isFiring(entry)) {
          // イベント発火
          emitIntersectEvent(vNode, entry)

          if (once) {
            disconnect(el)
          }
        }
      })
    }, observerOptions)

    // IntersectionObserverインスタンスの管理
    const id = String(currentId)
    currentId += 1
    observers[id] = observer
    // eslint-disable-next-line no-param-reassign
    el.dataset.intersectionObserverId = id

    // 対象要素の監視
    observer.observe(el)
  },
  unbind(el) {
    disconnect(el)
  },
}
